import {
  Checkbox,
  CheckboxGroup,
  Text
} from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow, { FilterGroup } from '../../reusable/Layout';

const MODIFIERS_OPTIONS = [
  { id: 'modifierGeneralDiscounts', label: 'RL_GeneralDiscount' },
  { id: 'modifierEmployeeDiscount', label: 'RL_EmployeeDiscount' },
  { id: 'modifierPriceOverride', label: 'RL_PriceOverride' },
  { id: 'modifierPromotion', label: 'RL_Promotion' },
];

const ModifierSelectors = ({ onFilterValueChange, translations }) => {
  const nposFilters = useSelector((state) => state.nposFilters);
  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_Modifiers}</Text>
        <CheckboxGroup
          onChange={(e) => onFilterValueChange({ id: e.target.id, value: !nposFilters[e.target.id] })}
        >
          {MODIFIERS_OPTIONS.map(({ id, label }) => (
            <Checkbox
              key={id}
              checked={nposFilters[id]}
              data-testid={`modifier-checkbox-${id}`}
              id={id}
              label={translations[label]}
            />
          ))}
        </CheckboxGroup>
      </FilterRow>
    </FilterGroup>
  );
};

ModifierSelectors.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default ModifierSelectors;
